import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

const ParsedFiltersDisplay = ({ parsedFilters, latencyMs }) => {
  if (!parsedFilters) return null;

  const chips = [];

  // Skills
  if (parsedFilters.skills?.length > 0) {
    parsedFilters.skills.forEach((skill, index) => {
      chips.push(<Chip key={`skill-${index}`} label={skill} size="small" variant="outlined" color="primary" />);
    });
  }

  // Years of Experience
  if (parsedFilters.min_years !== null || parsedFilters.max_years !== null) {
    let label = '';
    if (parsedFilters.min_years !== null && parsedFilters.max_years !== null) {
      label = `${parsedFilters.min_years}-${parsedFilters.max_years} yrs`;
    } else if (parsedFilters.min_years !== null) {
      label = `${parsedFilters.min_years}+ yrs`;
    } else if (parsedFilters.max_years !== null) {
      label = `Up to ${parsedFilters.max_years} yrs`;
    }
    chips.push(<Chip key="exp" label={label} size="small" variant="outlined" color="secondary" />);
  }

  // Budget
  if (parsedFilters.max_budget !== null) {
    let budgetLabel = '';
    if (parsedFilters.max_budget >= 100000) {
      budgetLabel = `≤₹${(parsedFilters.max_budget / 100000).toFixed(1)}L`;
    } else {
      budgetLabel = `≤₹${(parsedFilters.max_budget / 1000).toFixed(0)}k`;
    }
    chips.push(<Chip key="budget" label={budgetLabel} size="small" variant="outlined" color="success" />);
  }

  // Status
  if (parsedFilters.status) {
    chips.push(
      <Chip 
        key="status" 
        label={parsedFilters.status.replace(/_/g, ' ')} 
        size="small" 
        variant="outlined" 
      />
    );
  }

  // Location
  if (parsedFilters.location_city) {
    chips.push(<Chip key="location" label={parsedFilters.location_city} size="small" variant="outlined" />);
  }

  // Job Code
  if (parsedFilters.job_code) {
    chips.push(<Chip key="jobcode" label={parsedFilters.job_code} size="small" variant="outlined" />);
  }

  if (chips.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center', my: 2 }}>
      <Typography variant="caption" color="text.secondary">Filters detected:</Typography>
      {chips}
      <Typography variant="caption" color="text.secondary">• Parsed in {latencyMs}ms</Typography>
    </Box>
  );
};

export default ParsedFiltersDisplay;
